export default {
  showSubscriberModal: false,
  subscribersList: [],
  formData: null,
  subscribersListItem: null,
  interval: 0,
  subscribers: [],
  subScriberItem: null,
  guestItem: null,
  addDialogVisible: false,
  updateDialogVisible: false,
  profileId: null,
  subscriberProfile: null,
  locationIds: [],
  locationGroupIds:[],
  subscriberPage: { page: 1, itemsPerPage: 8, q: ""},
  guests: [],
  guestPage: { page: 1, itemsPerPage: 10, q: "" },
  subscriberPageS3: {pageFile:1, fileEndCount:100, totalRowsCount: 100},
  guestPageS3: { pageFile:1, fileEndCount:100, totalRowsCount: 100},
};
